import { Component, Input } from '@angular/core';

@Component({
  selector: 'single-tab',
  styles: [`
    .pane{
      padding: 1em;
    }
  `],
  template: `
  <div [hidden]="!active"  class="tab-pane">
      <ng-content></ng-content>
    </div>
  `
})
export class singleTab {
  @Input('tabTitle') title: string;
  @Input() active = false;
  @Input('tabIndex') tabIndex: number;
}